const Graph = require('./BaseGraph')

module.exports = class YfpGraph extends Graph 
{
    constructor(apiDomain, path="yfp")
    {
        super(apiDomain, path)
    }

}